import React from "react";
import { Link } from "react-router-dom";

import { Button } from "components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";

import { MEGA_MENU_PANEL_WIDTH } from "./useHoverDropdown";
import { MegaMenuCategoryColumn } from "./MegaMenuCategoryColumn";
import type { MegaMenuCategoryConfig, MegaMenuPanelLabels } from "./types";

interface MegaMenuPanelProps {
    categories: MegaMenuCategoryConfig[];
    labels: MegaMenuPanelLabels;
    onNavigate: () => void;
    className?: string;
}

export const MegaMenuPanel: React.FC<MegaMenuPanelProps> = ({ categories, labels, onNavigate, className }) => (
    <Card
        variant="menuPanel"
        className={className}
        style={{ width: MEGA_MENU_PANEL_WIDTH }}
        role="menu"
        aria-label={labels.ariaLabel}
    >
        <CardHeader variant="menuPanel">
            <CardTitle className="text-sm font-medium leading-none">{labels.title}</CardTitle>
            <Button variant="menuPanelAction" className="shrink-0" asChild>
                <Link to={labels.viewAllHref} onClick={onNavigate}>
                    {labels.viewAllLabel}
                </Link>
            </Button>
        </CardHeader>

        <CardContent variant="menuPanel">
            {categories.map((category) => (
                <MegaMenuCategoryColumn
                    key={category.id}
                    category={category}
                    onNavigate={onNavigate}
                    layout="desktop"
                />
            ))}
        </CardContent>
    </Card>
);
